module.exports = __webpack_public_path__ + "img/video-player/big-play-button-play-b73a208ccd932704893aaeadd061f4c8.svg";